import React from "react";
import styled from "styled-components";
import { Colors } from "../../config";

const DropdownPaymentType = ({
  closeDropdown,
  selected,
  onPayTypeSelect,
  payType,
}) => {
  const handleSelect = (selected) => {
    closeDropdown();
    onPayTypeSelect(selected);
  };
  return (
    <DropdownWrapper>
      <DropdownList>
        {payType.map((item, idx) => (
          <DropdownItem
            selected={item === selected}
            key={idx}
            onClick={() =>
              handleSelect({
                target: { value: item, name: "paymentType" },
              })
            }
          >
            {item}
          </DropdownItem>
        ))}
      </DropdownList>
    </DropdownWrapper>
  );
};

export default DropdownPaymentType;

// Styled Components

const DropdownWrapper = styled.div``;

const DropdownList = styled.div`
  list-style-type: none;
  padding: 0;
  margin: 0;
`;

const DropdownItem = styled.div`
  padding: 16px 12px;
  font-size: 0.9rem;
  cursor: pointer;
  transition: background-color 0.2s ease-in-out;
  color: ${(props) => (props.selected ? Colors.white : Colors.prussianBlue)};
  background: ${(props) =>
    props.selected ? Colors.prussianBlue : Colors.white};
  &:hover {
    background-color: ${(props) =>
      props.selected ? Colors.prussianBlue : "#f0f0f0"};
    color: ${(props) => (props.selected ? Colors.white : Colors.prussianBlue)};
  }
`;
